<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>La entrada triunfal de Iturbide a Ciudad de México y la firma del Acta de Independencia.</h2>
    <img @click="imageClicked(0)" src="galerias/independencia/g9/G9.jpg" class="mainphoto"/>
    <p>Después de la firma de los Tratados de Córdoba, Agustín de Iturbide, Vicente Guerrero y el Ejército Trigarante se dirigieron a Ciudad de México para hacer su entrada triunfal el 27 de septiembre de 1821. Esto se logró debido a que uno de los acuerdos con O’Donojú fue la salida del Ejército Realista de la capital.</p>
    <p>A su llegada, los generales y el ejército fueron recibidos con arcos triunfales que simbolizaban la victoria de este largo proceso de independencia que duró 11 años y que para ese momento era anhelado por gran parte de la población.</p>
    <p>Al día siguiente, el 28 de septiembre de 1821, ocurrió uno de los hechos más importantes de la historia de México, la firma del Acta de Independencia del Imperio Mexicano.</p>
    <p>Además se creó la Junta Provisional Gubernativa, tal y como lo indicaba el artículo 5 del Plan de Iguala, integrada por 38 personas que legislarán todo lo necesario para el nacimiento de esta nación.</p>
    <p>Así, podemos asegurar que el Plan de Iguala, los Tratados de Córdoba y el Acta de Independencia son documentos fundamentales para el nacimiento del México Independiente.</p>
    <h5>VER MÁS</h5>
    <p>Consulta el Acta de Independencia en el siguiente enlace:"
    <ul><li><a target="_blank" href="https://mediateca.inah.gob.mx/islandora_74/islandora/object/objetohistorico%3A2301">mediateca.inah.gob.mx</a></li></ul></p>
  </div>
</template>

<script>
export default {
  name: "Sala3m11",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
